module.exports = __webpack_public_path__ + "ed752926fcee6a1c899fa6a598f18375-Diggy.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/assets/Diggy.png
// module id = 594
// module chunks = 0